<template>
  <div ref="htmlContainer">
    <div style="margin:10px 0;width: 220px;">
      <template v-if="cascader_options">
        <el-cascader v-model="selected_val" :options="cascader_options" @change="handleChange">
        </el-cascader>
      </template>
      <template v-else>
        <el-select v-model="selected_val" placeholder="请选择" @change="handleChange">
          <el-option v-for="(value, key) in node_data" :key="key" :value="key">
            <div class="custom_option_box" :title="key">{{ key }}</div>
          </el-option>
        </el-select>
      </template>
    </div>

    <div v-if="isVisible && fileSrc" v-loading="is_loading">
      <iframe id="myIframe" :src="fileSrc" width="100%" height="500px"></iframe>
    </div>

  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { defaultFullRequestMethodGet } from '@/api/index.js';
  import { transformToCascaderData } from '@/utils/tool.js';
  const emit = defineEmits([])
  const props = defineProps(['data', 'task_result']);

  const selected_val = ref(null);
  const node_data = ref(null);
  const fileSrc = ref(null);
  const cascader_options = ref(null);
  const is_loading = ref(false);
  const isVisible = ref(false);
  const raw_data = ref(null);
  const node_data_token = ref(null);// 节点数据token

  const htmlContainer = ref(null);//html容器

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) { // 进入视口
      isVisible.value = true;
      observer.disconnect(); // 避免重复监听
      if (selected_val.value) fetchFileData(node_data.value[selected_val.value]);
    };
  }, { threshold: 0.1 });


  const initHtml = function () {
    if (raw_data.value?.process_report?.length > 0) {
      const defaultVal = raw_data.value.process_report[0].default_val;
      if (defaultVal) {
        selected_val.value = Object.keys(defaultVal)[0];
        node_data.value = defaultVal;
        // **不主动加载 HTML，等待进入视口**
        if (isVisible.value) {
          fetchFileData(defaultVal[selected_val.value]);
        }
      }
    }
  };

  const fetchFileData = function (fileSource) { // 获取文件数据
    const base64Pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
    const localPathPattern = /^\./; // 本地相对路径模式
    if (base64Pattern.test(fileSource) || localPathPattern.test(fileSource)) {
      fileSrc.value = fileSource;
    } else {
      is_loading.value = true;
      const url = process.env.VUE_APP_BASE_API + fileSource;
      defaultFullRequestMethodGet(url, {}).then((blob) => {
        fileSrc.value = URL.createObjectURL(blob);
        is_loading.value = false;
      }).catch((err) => {
        console.error('HTML 文件加载失败:', err);
        is_loading.value = false;
      });
    };
  };

  const handleChange = function (val) {
    let newFileSource = null;
    if (Array.isArray(val)) {
      let s_val = val.join('_');
      newFileSource = node_data.value[s_val];
    } else if (typeof val === 'string') {
      newFileSource = node_data.value[val];
    };
    if (newFileSource) fetchFileData(newFileSource);
  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props.task_result, (newData, oldData) => {
    let title = props.data.title;
    let node_result = newData[title];
    if (node_result) {
      raw_data.value.process_report[0].default_val = node_result.data;
      cascader_options.value = node_result.select_data ? transformToCascaderData(node_result.select_data) : null;
      initHtml();
    };
  });
  //组件即将挂载
  onBeforeMount(() => {
    raw_data.value = props.data;
  });
  //组件已经挂载
  onMounted(() => {
    observer.observe(htmlContainer.value);
    initHtml();
    node_data_token.value = PubSub.subscribe(props.data.title, function (msg, data) {
      raw_data.value.process_report[0].default_val = data.result.data;
      cascader_options.value = data.result.select_data ? transformToCascaderData(data.result.select_data) : null;
      initHtml();
    });
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    observer.disconnect();
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  #myIframe {
    border: none;
  }

  .custom_option_box {
    max-width: 200px;
    /* 超出显示省略号 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>